import { useTranslation } from 'react-i18next';

export default function PostSubmitGuide() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('contact.post.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('contact.post.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('contact.post.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {t('contact.post.lead')}
          </p>
        </div>

        <div className="space-y-6">
          {[1, 2, 3].map((step) => (
            <div key={step} className="flex items-start gap-5 p-6 bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-accent-500/30 bg-accent-500/[0.04] flex-shrink-0">
                <span className="text-accent-500 text-[15px] font-medium">{step}</span>
              </div>
              <div>
                <h3 className="text-[16px] text-foreground-800 tracking-[0.05em] mb-2 font-medium">
                  {t(`contact.post.step${step}.title`)}
                </h3>
                <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {t(`contact.post.step${step}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
